function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.69584 0 0 .75186 27.866 15.48)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 42.84,
  cy: 62.578,
  rx: 40.409,
  ry: 60.093
}), /*#__PURE__*/React.createElement("polyline", {
  points: "42.696 2.484 30.568 17.206 42.696 21.9 27.751 31.76 23.257 62.791 14.84 43.731 2.431 62.791"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "4.981 41.854 14.84 43.731 27.599 31.982 30.426 17.206 24.024 9.447"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "30.426 17.328 10.973 25.703 14.663 43.555"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "42.549 2.484 54.677 17.206 42.696 21.9 57.494 31.76 62.423 62.791 70.404 43.731 83.249 62.791"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "80.264 41.854 70.404 43.731 57.646 31.982 54.818 17.206 61.221 9.447"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "54.818 17.328 74.271 25.703 70.582 43.555"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "42.985 122.67 55.111 107.95 42.696 103.26 57.93 93.396 62.423 62.791 70.84 81.426 83.249 62.791"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "80.699 83.303 70.84 81.426 58.082 93.174 55.254 107.95 61.656 115.71"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "55.254 107.83 74.708 99.453 71.018 81.604"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "43.132 122.67 31.004 107.95 42.696 103.26 28.187 93.396 23.257 62.791 15.276 81.426 2.431 62.791"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "5.417 83.303 15.276 81.426 28.035 93.174 30.862 107.95 24.46 115.71"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "30.862 107.83 11.409 99.453 15.099 81.604"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.69584 0 0 .75186 95.748 15.19)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 42.84,
  cy: 62.578,
  rx: 40.409,
  ry: 60.093
}), /*#__PURE__*/React.createElement("polyline", {
  points: "42.696 2.484 30.568 17.206 42.696 21.9 27.751 31.76 23.257 62.791 14.84 43.731 2.431 62.791"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "4.981 41.854 14.84 43.731 27.599 31.982 30.426 17.206 24.024 9.447"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "30.426 17.328 10.973 25.703 14.663 43.555"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "42.549 2.484 54.677 17.206 42.696 21.9 57.494 31.76 62.423 62.791 70.404 43.731 83.249 62.791"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "80.264 41.854 70.404 43.731 57.646 31.982 54.818 17.206 61.221 9.447"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "54.818 17.328 74.271 25.703 70.582 43.555"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "42.985 122.67 55.111 107.95 42.696 103.26 57.93 93.396 62.423 62.791 70.84 81.426 83.249 62.791"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "80.699 83.303 70.84 81.426 58.082 93.174 55.254 107.95 61.656 115.71"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "55.254 107.83 74.708 99.453 71.018 81.604"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "43.132 122.67 31.004 107.95 42.696 103.26 28.187 93.396 23.257 62.791 15.276 81.426 2.431 62.791"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "5.417 83.303 15.276 81.426 28.035 93.174 30.862 107.95 24.46 115.71"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "30.862 107.83 11.409 99.453 15.099 81.604"
}));

const SvgOvalPair = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  width: 183,
  height: 125,
  enableBackground: "new 0 0 85.5 125",
  viewBox: "0 0 183 125",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOvalPair, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/oval-pair.9c2047a5.svg";
export { ForwardRef as ReactComponent };